import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

export default function HomePage() {
  const { t } = useTranslation('home');

  const tiles = [
    {
      icon: 'ri-line-chart-line',
      title: t('tiles.investments.title'),
      description: t('tiles.investments.description')
    },
    {
      icon: 'ri-safe-line',
      title: t('tiles.assetManagement.title'),
      description: t('tiles.assetManagement.description')
    },
    {
      icon: 'ri-shield-check-line',
      title: t('tiles.governance.title'),
      description: t('tiles.governance.description')
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CookieBanner />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        <div className="absolute inset-0 flex">
          <div className="w-1/2 bg-[#E8F4F8]"></div>
          <div className="w-1/2 relative">
            <img
              src="https://static.readdy.ai/image/10b7ac0fbf41ce1a59b0bea485f34628/bba377750a6a4511b3b035ccdb4b5369.png"
              alt="Corporate Architecture"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
          </div>
        </div>

        <div className="relative z-10 max-w-[1440px] mx-auto px-10 w-full">
          <div className="w-[45%]">
            <h1
              className="text-7xl font-bold text-[#0A2D50] leading-tight mb-8"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              {t('hero.title')}
            </h1>
            <p className="text-2xl text-[#0A2D50]/85 mb-12 leading-relaxed">
              {t('hero.subtitle')}
            </p>
            <p className="text-base text-[#0A2D50]/70 mb-14 leading-relaxed max-w-[520px]">
              {t('hero.intro')}
            </p>
            <div className="flex gap-4">
              <Link
                to="/structure"
                className="bg-[#1BCDFF] text-white px-8 py-3 rounded-[28px] text-sm font-medium hover:bg-[#1EB7EC] transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {t('hero.viewStructure')}
              </Link>
              <a
                href="mailto:info@group-dr.com"
                className="border-[1.5px] border-[#0A2D50] text-[#0A2D50] px-8 py-3 rounded-[28px] text-sm font-medium hover:bg-[#0A2D50] hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {t('hero.contact')}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Tiles Section */}
      <section className="py-32 bg-white">
        <div className="max-w-[1280px] mx-auto px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {tiles.map((tile, index) => (
              <div
                key={index}
                className="bg-[#F2F4F5] p-12 rounded-2xl hover:shadow-lg transition-all duration-300"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-[#1BCDFF]/10 rounded-xl mb-6">
                  <i className={`${tile.icon} text-2xl text-[#1BCDFF]`}></i>
                </div>
                <h3 className="text-xl font-semibold text-[#0A2D50] mb-4">
                  {tile.title}
                </h3>
                <p className="text-base text-gray-600 leading-relaxed">
                  {tile.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}